import { FC } from 'react'

export type LeaseDetailTabKey =
  | 'generales'
  | 'condiciones'
  | 'amortizacion'
  | 'pagos'

interface LeaseDetailTabsProps {
  active: LeaseDetailTabKey
  onChange: (tab: LeaseDetailTabKey) => void
  // true para solicitudes rechazadas: nunca hubo cotización final aceptada,
  // así que Condiciones/Tabla de amortización/Pagos no aplican.
  onlyGenerales?: boolean
}

const TABS: { key: LeaseDetailTabKey; label: string }[] = [
  { key: 'generales', label: 'DATOS GENERALES' },
  { key: 'condiciones', label: 'CONDICIONES DE ARRENDAMIENTO' },
  { key: 'amortizacion', label: 'TABLA DE AMORTIZACIÓN' },
  { key: 'pagos', label: 'PAGOS' },
]

// A diferencia de LeaseTabs/ProposalTabs (ancho completo), en "Detalle de
// arrendamiento" las tabs van alineadas a la izquierda con ancho natural —
// mismas clases de borde/color activo, sin flex-1.
export const LeaseDetailTabs: FC<LeaseDetailTabsProps> = ({
  active,
  onChange,
  onlyGenerales,
}) => {
  const tabs = onlyGenerales ? TABS.filter(tab => tab.key === 'generales') : TABS

  return (
    <div className="flex gap-8 border-b border-olr-grey-2 mb-6">
      {tabs.map(tab => (
        <button
          key={tab.key}
          type="button"
          onClick={() => onChange(tab.key)}
          className={`px-1 py-3 text-xs font-semibold tracking-wide text-center border-b-2 transition-colors ${
            active === tab.key
              ? 'border-olr-primary text-olr-primary'
              : 'border-transparent text-olr-body hover:text-olr-dark'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
